export const PERSONVERN_URL = "https://www.nav.no/personvern";
export const KONTAKT_INFO_URL_AG = "https://arbeidsgiver.nav.no/kontakt-oss/";
export const KONTAKT_INFO_URL_SM = "https://www.nav.no/still-sporsmal";
export const ARBEIDSGIVER_OPPFOLGING_INFO_URL =
  "https://www.nav.no/arbeidsgiver/oppfolging-sykmeldte";
export const ARBEIDSGIVER_DIALOGMOTE_MED_NAV_INFO_URL =
  "https://www.nav.no/arbeidsgiver/oppfolging-sykmeldte#dialogmote-2og3";
export const SYKMELDT_DIALOGMOTE_MED_NAV_INFO_URL =
  "https://www.nav.no/dialogmote#Dialogmote-2-og-3";
export const ARBEIDSGIVER_VIRKEMIDLER_OG_TILTAK_INFO_URL =
  "https://www.nav.no/arbeidsgiver/oppfolging-sykmeldte#virkemidler";
export const VIDEOMOTE_INFO_URL =
  "https://www.nav.no/brukerstotte#videomote-med-nav";
export const TIDSLINJE_URL = "/tidslinjen";
